export default "__VITE_ASSET__DshUW58f__"